import {
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE,
  MARK_AS_READ,
  MARK_AS_READ_SUCCESS,
  MARK_AS_READ_FAILURE,
  MARK_AS_READ_SINGLE,
  MARK_AS_READ_SINGLE_SUCCESS,
  MARK_AS_READ_SINGLE_FAILURE,
  MARK_AS_SEEN,
  MARK_AS_SEEN_SUCCESS,
  MARK_AS_SEEN_FAILURE,
  CREATE_SUPPORT,
  CREATE_SUPPORT_SUCCESS,
  CREATE_SUPPORT_FAILURE,
} from "../constants";

const initialState = {
  notifications: [],
  notificationCount: 0,
  isLoading: false,
  isSeenLoading: false,
  isSingleLoading: false,
  isSupportLoading: false,
  error: null,
};

export default function NotificationReducer(state = initialState, action) {
  switch (action.type) {
    case GET_NOTIFICATIONS:
    case MARK_AS_READ:
      state = {
        ...state,
        isLoading: true,
        error: null,
      };
      break;
    case MARK_AS_READ_SINGLE:
      state = {
        ...state,
        isSingleLoading: true,
        error: null,
      };
      break;
    case MARK_AS_SEEN:
      state = {
        ...state,
        isSeenLoading: true,
        error: null,
      };
      break;
    case CREATE_SUPPORT:
      state = {
        ...state,
        isSupportLoading: true,
        error: null,
      };
      break;
    case GET_NOTIFICATIONS_SUCCESS:
      state = {
        ...state,
        notifications: action.payload.notifications,
        notificationCount: action.payload.count,
        isLoading: false,
      };
      break;
    case MARK_AS_READ_SUCCESS:
      state = {
        ...state,
        isLoading: false,
      };
      break;
    case MARK_AS_READ_SINGLE_SUCCESS:
      state = {
        ...state,
        isSingleLoading: false,
      };
      break;
    case MARK_AS_SEEN_SUCCESS:
      state = {
        ...state,
        isSeenLoading: false,
      };
      break;
    case CREATE_SUPPORT_SUCCESS:
      state = {
        ...state,
        isSupportLoading: false,
      };
      break;

    case GET_NOTIFICATIONS_FAILURE:
      state = {
        ...state,
        isLoading: false,
        notifications: [],
        notificationCount: 0,
        error: action.payload,
      };
      break;
    case MARK_AS_READ_FAILURE:
      state = {
        ...state,
        isLoading: false,
        error: action.payload,
      };
      break;
    case MARK_AS_READ_SINGLE_FAILURE:
      state = {
        ...state,
        isSingleLoading: false,
        error: action.payload,
      };
      break;
    case MARK_AS_SEEN_FAILURE:
      state = {
        ...state,
        isSeenLoading: false,
        error: action.payload,
      };
      break;
    case CREATE_SUPPORT_FAILURE:
      state = {
        ...state,
        isSupportLoading: false,
        error: action.payload,
      };
      break;
    default:
      break;
  }

  return state;
}
